import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { RoomsModel } from '../models/RoomsModel';
import { URLsConfig } from '../URLsConfig';


@Injectable()
export class RoomsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getRooms(roomCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("roomCode", roomCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<RoomsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Rooms/Getrooms',options);
    }


    public AddRooms(rooms: RoomsModel) {
        return this.http.post<RoomsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Rooms/AddRooms', rooms);
    }
    public delRooms(roomCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("roomCode", roomCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<RoomsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Rooms/Deleterooms',options);
    }

    public getRoomsLookup(roomCode: string, roomName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("roomCode", roomCode);
      params = params.append("romName", roomName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<RoomsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Rooms/RoomsLookup', options);
  }

  public getRoomsLookupTop(compCode: string) {
    let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<RoomsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Rooms/RoomsLookupTop', options);
      }

}
